<div class="container-workers">
    <div class="container-workers__wrapper">
        <div class="header flex-row">
            <button (click)="back()" [disabled]="isSaving" class="header__back">
                <i class="pi pi-angle-left"></i>
            </button>
            <h1 class="header__title">
                {{'worker.configure-worker'|translate}}
            </h1>
        </div>

        <form [formGroup]="form">
            <div class="content">
                <div class="form-wrapper">
                    <div class="form-wrapper__form row">
                      <div class="form-wrapper__form__column">
                        <h2 class="form-wrapper__form__title">
                          {{'worker.basic-data'|translate}}
                        </h2>
                        <input
                          formControlName="firstName"
                          type="text"
                          pInputText
                          [placeholder]="'labels.first-name' | translate"
                          [ngClass]="{
                            'custom-invalid': form.get('firstName')?.invalid && form.get('firstName')?.touched
                          }"
                        />
                        <input
                          formControlName="lastName"
                          type="text"
                          pInputText
                          [placeholder]="'labels.last-name' | translate"
                          [ngClass]="{
                            'custom-invalid': form.get('lastName')?.invalid && form.get('lastName')?.touched
                          }"
                        />
                        <p-treeselect
                          class="w-full"
                          formControlName="organization"
                          [options]="treeNodeOrganizations"
                          [filter]="true"
                          [placeholder]="'vehicle-indicator.group' | translate"
                          [ngClass]="{
                            'custom-invalid': form.get('organization')?.invalid && form.get('organization')?.touched
                          }"
                        />
                        <input
                          formControlName="phone"
                          type="text"
                          pInputText
                          [placeholder]="'labels.phone-number-optional' | translate"
                        />
                        <div class="form-wrapper__form__control-wrapper">
                          <div class="form-wrapper__form__control-wrapper__input-wrapper">
                            <input
                              formControlName="email"
                              type="text"
                              pInputText
                              [placeholder]="
                                form.get('mycarapp')?.value
                                  ? ('fields-names.email' | translate)
                                  : ('labels.email-optional' | translate)
                              "
                              [ngClass]="{
                                'custom-invalid': form.get('email')?.invalid && form.get('email')?.touched
                              }"
                            />
                          </div>
                          <div *ngIf="emailControl?.invalid && emailControl?.touched">
                            <small class="error-text">
                              {{'requiredFieldToCreateAccountError' | translate}}
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="form-wrapper__form__column">
                      </div>
                    </div>

                    <div class="form-wrapper__form row">
                      <div class="form-wrapper__form__column">
                        <h2 class="form-wrapper__form__title">
                          {{'driverLicense' | translate}}
                        </h2>
                        <div class="form-wrapper__form__control-wrapper__input-wrapper">
                          <input formControlName="driverLicense" type="text" pInputText [placeholder]="'driverLicenseInputPlaceholder'|translate" />
                          <div *ngIf="driverLicesnseControl?.invalid && driverLicesnseControl?.touched">
                            <small class="error-text">
                              {{'errorDriverLicenseNumber' | translate}}
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="form-wrapper__form__column">
                        <h2 class="form-wrapper__form__title">
                          {{'driverLicenseHint.wherFindNumber' | translate}}
                        </h2>
                        <div class="form-wrapper__form__license-imgs">
                          <div class="form-wrapper__form__license-imgs__column">
                            <span>
                              {{'driverLicenseHint.physicalDocument'|translate}}
                            </span>
                            <img src="/assets/img/driver-license-hint.png" alt="driver license hint">
                          </div>
                          <div class="form-wrapper__form__license-imgs__column">
                            <span>
                              {{'driverLicenseHint.mObywatelApp'|translate}}
                            </span>
                            <img src="/assets/img/driver-license-hint-mObywatel.png" alt="driver license hint">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="hasAccessToCreateAccountUser" class="form-wrapper__form mycar-app">
                      <h2 class="form-wrapper__form__title">
                        {{'accessToMyCarApp' | translate}}
                      </h2>
                      <p-toggleSwitch class="form-wrapper__form__mycar-switch" formControlName="mycarapp"/>
                      <span
                        [ngClass]="{
                          'active': form.get('mycarapp')?.value && editedWorkerData?.U,
                          'no-active': (!form.get('mycarapp')?.value && editedWorkerData?.U)
                        }"
                        class="form-wrapper__form__mycar-status"
                      >
                      <!-- 'first-save': form.get('mycarapp')?.value && !editedWorkerData?.U -->
                      <!-- 'no-active': (!form.get('mycarapp')?.value && editedWorkerData?.U) || (!form.get('mycarapp')?.value && !editedWorkerData?.U), -->
                      {{
                        editedWorkerData?.U
                          ? (
                              form.get('mycarapp')?.value
                                ? ('activeAccess' | translate)
                                : ('accessRemoveAfterSave' | translate)
                            )
                          : (
                              form.get('mycarapp')?.value
                                ? ('accountCreateAfterSave' | translate)
                                : ('noAccess' | translate)
                            )
                      }}
                      </span>
                    </div>

                    <div class="actions-form">
                        <button (click)="submit()" [disabled]="isSaving" pButton type="button" [label]="'labels.save'|translate" class="actions-form__submit"></button>
                        <button (click)="back()" [disabled]="isSaving" pButton pRipple type="button" [label]="'labels.cancel'|translate" class="p-button-text p-button-plain" icon="pi pi-times" iconPos="left"></button>
                    </div>

                    <div *ngIf="!isAddNewWorker" class="archive-worker">
                        <span class="archive-worker__title">
                            {{'worker.archive-worker'|translate}}
                        </span>
                        <button (click)="archiveWorker()" pButton pRipple type="button" [disabled]="isSaving || editedWorkerData?.U" [label]="'worker.move-to-archive'|translate" class="p-button-danger p-button-text" icon="pi pi-inbox" iconPos="left"></button>
                    </div>
                </div>
            </div>
        </form>

    </div>
</div>

<ng-template #driverLicenseHintTooltip>
  <app-driver-license-hint></app-driver-license-hint>
</ng-template>
